export function sortByProperty(propName) {
    return (a, b) => {
        let aText = a[propName].toUpperCase();
        let bText = b[propName].toUpperCase();
        if (aText < bText) {
            return -1
        }
        if (aText > bText) {
            return 1
        }
        return 0
    }
}
